/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IRemessaPlanilhaDownloadRepository } from "@/repositories/remessas/types";

import { extrairNomeArquivoDoContentDisposition, montarNomeArquivoFallback } from "./helpers";

const remessaDownloadPlanilhaRepository: IRemessaPlanilhaDownloadRepository = {
  /**
   * Função para fazer download do arquivo csv da remessa
   * @param accessToken
   * @param cliente_id
   * @returns Promise<any | null>
   */
  async getDownloadPlanilhaRemessa<T>(
    accessToken: string,
    remessa_id: number,
    planilhaNome: string
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const response = await Instance.get(`remessas/${remessa_id}/planilha/download`, {
      responseType: "blob",
      headers: {
        Accept: "*/*",
      },
    });

    const contentDisposition =
      (response.headers["content-disposition"] as string | undefined) ??
      (response.headers["Content-Disposition"] as string | undefined);
    const contentType =
      (response.headers["content-type"] as string | undefined) ?? response.data?.type;

    const nomeArquivo =
      extrairNomeArquivoDoContentDisposition(contentDisposition) ??
      montarNomeArquivoFallback(planilhaNome, remessa_id, contentType);

    // cria um blob e força o download no navegador
    const blob = new Blob([response.data], {
      type: contentType ?? "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();

    // Limpa referências
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return null;
  },
};

/**
 * EXPORTS
 */
export { remessaDownloadPlanilhaRepository };
